<script setup lang="ts">
  withDefaults(defineProps<{ size?: number | string }>(), { size: 16 })
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M18 18H7a4.5 4.5 0 0 1-.6-8.96A6 6 0 0 1 17.9 9.5H18a4.25 4.25 0 0 1 0 8.5z" />
  </svg>
</template>
